import React from 'react';
import { Spinner, Robot, Lightning } from '@phosphor-icons/react';

export const LegalPanelInputs = ({
  country, setCountry, stateVal, setStateVal, city, setCity, incident, setIncident,
  suggest, suggesting, generate, generating, panel, suggestionMeta,
}) => (
  <>
    {/* Input form */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
      <div>
        <label className="block text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm mb-1">Country</label>
        <input data-testid="legal-panel-country-input" value={country} onChange={e => setCountry(e.target.value)}
          placeholder="e.g., India" className="w-full px-3 py-2 border border-[#E5E7EB] rounded-md text-sm font-ibm focus:outline-none focus:ring-1 focus:ring-[#002FA7] focus:border-[#002FA7]" />
      </div>
      <div>
        <label className="block text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm mb-1">State / Province</label>
        <input data-testid="legal-panel-state-input" value={stateVal} onChange={e => setStateVal(e.target.value)}
          placeholder="e.g., Maharashtra" className="w-full px-3 py-2 border border-[#E5E7EB] rounded-md text-sm font-ibm focus:outline-none focus:ring-1 focus:ring-[#002FA7] focus:border-[#002FA7]" />
      </div>
      <div>
        <label className="block text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm mb-1">City</label>
        <input data-testid="legal-panel-city-input" value={city} onChange={e => setCity(e.target.value)}
          placeholder="e.g., Mumbai" className="w-full px-3 py-2 border border-[#E5E7EB] rounded-md text-sm font-ibm focus:outline-none focus:ring-1 focus:ring-[#002FA7] focus:border-[#002FA7]" />
      </div>
      <div>
        <label className="block text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm mb-1">Incident / Issue Type</label>
        <input data-testid="legal-panel-incident-input" value={incident} onChange={e => setIncident(e.target.value)}
          placeholder="e.g., Workplace harassment" className="w-full px-3 py-2 border border-[#E5E7EB] rounded-md text-sm font-ibm focus:outline-none focus:ring-1 focus:ring-[#002FA7] focus:border-[#002FA7]" />
      </div>
    </div>

    <div className="flex flex-wrap gap-2 items-center mb-2">
      <button onClick={suggest} disabled={suggesting || generating} data-testid="legal-panel-suggest-button"
        className="flex items-center gap-1.5 px-3 py-2 text-sm border border-[#E5E7EB] text-[#09090B] font-ibm rounded-md hover:bg-[#F3F4F6] transition-all disabled:opacity-50">
        {suggesting ? <><Spinner size={14} className="animate-spin" /> Detecting from case...</> : <><Robot size={14} /> Auto-suggest from case</>}
      </button>
      <button onClick={generate} disabled={generating || suggesting} data-testid="legal-panel-generate-button"
        className="flex items-center gap-1.5 px-3 py-2 text-sm bg-[#002FA7] text-white font-ibm font-semibold rounded-md hover:bg-[#00237D] transition-all disabled:opacity-50">
        {generating ? <><Spinner size={14} className="animate-spin" /> Generating...</> : <><Lightning size={14} /> {panel ? 'Regenerate Panel' : 'Generate Panel'}</>}
      </button>
      {suggestionMeta && (
        <span className={`text-xs font-ibm px-2 py-1 rounded border ${suggestionMeta.confidence === 'high' ? 'bg-green-50 text-green-700 border-green-200' : suggestionMeta.confidence === 'medium' ? 'bg-amber-50 text-amber-700 border-amber-200' : 'bg-gray-50 text-gray-700 border-gray-200'}`}>
          AI confidence: {suggestionMeta.confidence || 'low'}
        </span>
      )}
    </div>
    {suggestionMeta?.reasoning && (
      <p className="text-xs text-[#6B7280] font-ibm italic mb-2">Why: {suggestionMeta.reasoning}</p>
    )}
  </>
);
